export default __webpack_public_path__ + "static/media/T13B.7ac5c239.png";